import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";

import WorkshopB2BDataService from "../../services/WorkshopB2B";

export const DeleteB2BWorkshopModal = ({ isOpen, onClose, id, func }: any) => {
  const deleteWorkshop = () => {
    WorkshopB2BDataService.deleteB2BWorkshop(id)
      .then((response: any) => {
        func(true);
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Workshop</ModalHeader>
        <ModalCloseButton />
        <ModalBody>Are you sure you want to delete workshop?</ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={deleteWorkshop}
          >
            Delete
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
